import { useQuery } from '@tanstack/react-query';

import { paymentAccountDetailQueryOptions } from '@lib/query/options/payment';
import { convertToLocale } from '@lib/util/money';

export const CodRefundBalanceBlock = () => {
  const { data: accountDetail, isLoading, isError } = useQuery(
    paymentAccountDetailQueryOptions()
  );

  if (isLoading) return null;

  if (isError) {
    return (
      <div className="border-white-40 mb-8 flex min-h-[130px] w-full items-center rounded-md border">
        <div className="text-grey-60 w-full px-4 py-6 text-center">
          無法取得帳戶資訊，請稍後再試
        </div>
      </div>
    );
  }

  if (!accountDetail) return null;

  return (
    <div
      className="border-white-40 mb-8 flex min-h-[130px] w-full items-center rounded-md border"
      data-testid="cod-refund-balance-container"
    >
      <div className="flex-1 px-4 py-6">
        <span className="text-black-10 mr-2 h-full text-base">
          退貨退款餘額
        </span>
        <span
          className="text-black-40 text-xl font-bold"
          data-testid="cod-refund-balance-total"
        >
          {convertToLocale({
            amount: accountDetail?.codRefundBalance ?? 0,
            currency_code: 'twd',
          })}
        </span>
      </div>
      <div className="bg-white-40 min-h-[130px] w-[1px]"></div>
      <div className="flex-1 px-4 py-6">
        <span className="text-black-10 mr-2 h-full text-base">應付金額</span>
        <span
          className="text-black-40 text-xl font-bold"
          data-testid="cod-refund-balance-payable"
        >
          {convertToLocale({
            amount: accountDetail?.codOutstandingBalance ?? 0,
            currency_code: 'twd',
          })}
        </span>
        <div className="text-grey-60 mt-1">
          商品送達後請現場付款予物流人員，款項將於 7
          個工作日內完成入帳。入帳前將暫停下單，敬請留意，感謝您的配合。
        </div>
      </div>
    </div>
  );
};

export default CodRefundBalanceBlock;
